
import webApi from './webApi'


const accessLogService = {

    queryVisitorAccessLog : async(search)=>{
        return await webApi.httpPost('accesslog/visitors', search)
    },

    queryCourierAccessLog : async(search)=>{
        return await webApi.httpPost('accesslog/couriers', search)
    },

    queryAuditLog : async(search)=>{
        return await webApi.httpPost('accesslog/auditlogs', search)
    },

    
    queryVisitor : async(searchCriteria)=>{
        return await webApi.httpPost('query/visitor', searchCriteria)
    },


}




export default accessLogService